import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import WebService from '@util/webService'
import { isAdmin } from '@util/helper'
import SettingsIcon from '@mui/icons-material/Settings'
import FlatButton from '@components/FlatButton'
import ConfirmDialog from '@components/ConfirmDialog'
import MyDialog3 from '@components/MyDialog3'
import useSnackbar from '@hooks/useSnackbar'
import ChatList from '@pages/common/chat-list'
import ManagerChatPartSetting from './manager-chat.part.setting'

// 관리 칸: 설정(강좌 지정), 삭제(어드민)
const ManagerChatActions = ({ row, reload }) => {
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)
  const [openSnackbar] = useSnackbar()
  const settingHandler = useState(false)

  const onDelete = async () => {
    const url = `/chat/${row.id}/school/${schola.id}`
    const resp = await WebService.delete(url, { id: row.id })
    if(resp.repCode === 'ack') {
      reload()
      openSnackbar('삭제되었습니다.')
    }
    else {
      openSnackbar(resp.repMessage)
    }
  }

  return (
    <>
      {settingHandler[0] ? (
        <MyDialog3
          title={'문의 설정'}
          windowWidth="sm"
          dialogHandler={settingHandler}
          placeClose={true}
          component=<ManagerChatPartSetting record={row} dialogHandler={settingHandler} callback={reload} />
        />
      ) : null}
      <FlatButton style={{ marginRight: 5 }} onClick={() => settingHandler[1](true)} startIcon={<SettingsIcon />}>설정</FlatButton>
      {isAdmin(account) ? (
        <ConfirmDialog
          btn={<FlatButton color='error'>삭제(어드민권한)</FlatButton>}
          title={'주의'}
          content={'데이터를 삭제하시겠습니까?'}
          bc={'warning'}
          perform={onDelete}
        />
      ) : null}
    </>
  )
}

const ManagerChatPage = () => {
  return (
    <ChatList actions={(row, reload) => <ManagerChatActions row={row} reload={reload} />} />
  )
}

export default ManagerChatPage
